export default "__VITE_ASSET__CCrbIl$9__"